import { Card, CardContent, CardHeader, Typography } from '@mui/material'
import Grid2 from '@mui/material/Grid2'
import React from 'react'

import { Select } from '@/app/component/atom/form'
import { useGetWhatsappSenderOptions } from '@/app/module/common/hooks/use-get-whatsapp-sender-options'

type Props = {
  senderId: string
  onChange: (senderId: string) => void
}

const ChatbotPhoneNumber: React.FC<Props> = ({ senderId, onChange }) => {
  const { senderIds } = useGetWhatsappSenderOptions()

  return (
    <Card sx={{ mb: 4 }}>
      <CardHeader title="Sender ID" sx={{ py: 1.5, px: 3 }} />
      <CardContent>
        <Grid2 container spacing={1} sx={{ mb: 2 }}>
          <Grid2 size={12}>
            <Typography variant="body1">
              Select which Sender ID the chatbot should use when sending WhatsApp messages to contacts.
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2 container spacing={1} alignItems="center">
          <Grid2 size={{ xs: 12, md: 5 }}>
            <Typography variant="body1" sx={{ py: 1 }}>
              WhatsApp Phone Number
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 3 }}>
            <Select
              id="chatbot-sender-id"
              name="chatbot-sender-id"
              data-testid="chatbot-sender-id"
              editable
              value={senderId}
              values={senderIds}
              error={senderId ? '' : 'You must select a sender ID.'}
              onChange={({ value }: { value: string }) => onChange(value)}
            />
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  )
}

export default ChatbotPhoneNumber
